import { $tracing } from '../tracing';

export const tgBindCallback = ({ newParams }: { newParams: any }) => {
  $tracing.addEvent({
    t: 'TG BIND CALLBACK',
    ext: { newParams },
  });
};

export const tgBindResult = ({
  result,
  msg = '',
}: {
  result: boolean;
  msg?: string;
}) => {
  $tracing.addEvent({
    t: 'TG BIND RESULT',
    ext: {
      result,
      msg,
    },
  });
};
